import React from 'react'
import { Button } from 'react-bootstrap'
import './CookieAlert.scss'

// Localization
import { FormattedMessage } from 'react-intl'

const CookieAlert = (props) => {

  const acceptCookies = () => {
    localStorage.setItem('cookies-accepted', 'true')
    window.dispatchEvent(new Event('cookieConsentChanged'))
    props.setHideCookieAlert(true)
  }

  const acceptOnlyEssentialCookies = () => {
    localStorage.setItem('cookies-accepted', 'essential')
    props.setHideCookieAlert(true)
  }

  const rejectCookies = () => {
    localStorage.setItem('cookies-accepted', 'false')
    props.setHideCookieAlert(true)
  }

  return (
    <div className='CookieAlertContainer'>
      <div className='CookieAlert'>
        <h2><FormattedMessage id='general.cookieSettings' /></h2>
        <p>
          <FormattedMessage id='general.cookieNotice' />
        </p>
        <h3><FormattedMessage id='general.essentialCookies' /></h3>
        <p>
          <FormattedMessage id='general.essentialCookiesNotice' />
        </p>
        <p>
          <FormattedMessage id='general.essentialCookiesWarning' />
        </p>
        <h3><FormattedMessage id='general.optionalCookies' /></h3>
        <p>
          <FormattedMessage id='general.optionalCookiesNotice' />
        </p>
        <div className='CookieButtonGroup'>
          <Button variant='primary' onClick={acceptCookies}>
            <FormattedMessage id='general.acceptCookies' />
          </Button>
          <Button variant='primary' onClick={acceptOnlyEssentialCookies}><FormattedMessage id='general.acceptOnlyEssentialCookies' /></Button>
          <Button variant='outline-secondary' onClick={rejectCookies}><FormattedMessage id='general.rejectCookies' /></Button>
        </div>
      </div>
    </div>

  )
}

export default CookieAlert
